import { useEffect, useState } from 'react';

export enum UserPreferenceKey {
   CoursesPerPage = 'courses.manage.perPage',
   CourseAssigneesUsersPerPage = 'courses.assignees.users.perPage',
   CourseAssigneesTeamsPerPage = 'courses.assignees.teams.perPage',
}

const STORAGE_PREFIX = 'userpref:';
const storageKey = (key: UserPreferenceKey) => `${STORAGE_PREFIX}${key}`;

export function useUserPreference<T>(key: UserPreferenceKey, defaultValue: T) {
   const [value, setValue] = useState<T>(defaultValue);
   const [isHydrated, setIsHydrated] = useState(false);

   useEffect(() => {
      if (typeof window === 'undefined') return;

      const raw = window.localStorage.getItem(storageKey(key));
      if (raw != null) {
         setValue(JSON.parse(raw) as T);
      }

      setIsHydrated(true);
   }, [key]);

   useEffect(() => {
      if (!isHydrated || typeof window === 'undefined') return;
      window.localStorage.setItem(storageKey(key), JSON.stringify(value));
   }, [key, value, isHydrated]);

   return [value, setValue] as const;
}
